import { ReactElement } from 'react';
import { Loading } from '../shared/loading/Loading';
import { Drawer } from '../shared/drawer/Drawer';
import styles from './CartDrawerLoading.module.scss';

type Props = {
  isDrawerOpen: boolean;
  handleClose: () => void;
}

export function CartDrawerLoading({ isDrawerOpen, handleClose }: Props): ReactElement {
  const numberOfItems = 3;

  const listItems: ReactElement[] = [];
  for (let i = 0; i < numberOfItems; i++) {
    listItems.push(
      <div key={i}>
        <div className={styles.shopping_cart_list_item}>
          <Loading height={78} width={78.205} />
          <div className={styles.shopping_cart_description_skeleton}>
            <Loading height={14} />
            <Loading height={10} width={122} />
            <Loading height={10} width={122} />
          </div>
          <div className={styles.shopping_cart_right_loader}>
            <div className={styles.shopping_cart_right_skeleton_line}>
              <Loading height={16} width={50} />
            </div>
            <div className={styles.shopping_cart_quantity_selector}>
              <Loading height={32} width={32} radius={32} />
              <span className={styles.shopping_cart_quantity}>1</span>
              <Loading height={32} width={32} radius={32} />
            </div>
          </div>
        </div>
      </div>,
    );
  }
  return (
    <Drawer
      isOpen={isDrawerOpen}
      onClose={handleClose}
      content={(
        <>
          <div className={styles.shopping_cart_drawer_container}>
            <div className={styles.shopping_cart_item_list}>
              {listItems}
              <Loading height={38} width={381} />
            </div>
            <div className={styles.shopping_cart_footer}>
              <Loading height={16} />
              <Loading height={50} />
              <Loading height={10} />
            </div>
          </div>
        </>

          )}
      header={(
        <div className={styles.shopping_cart_header}>
          <div className={styles.shopping_cart_top}>
            <Loading height={12} />
            <Loading height={12} width={122.211} />
          </div>
          <div className={styles.shopping_cart_skip_btn}>
            <Loading height={12} width={33} />
          </div>
        </div>
          )}
    />
  );
}
